import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import Common from './modules/common'
import SquareFootage from './modules/square-footage'
import ShingleLayers from './modules/shingle-layers'
import Complexity from './modules/complexity'
import PitchAngle from './modules/pitch-angle'
import Material from './modules/material'
import Labor from './modules/labor'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  mutations: {
  },
  actions: {
  },
  modules: {
    Common,
    SquareFootage,
    ShingleLayers,
    Complexity,
    PitchAngle,
    Material,
    Labor,
  }
})
